import IPanel from '../models/panel-model';
import IFilter from '../models/filter-model';
import { IConfig } from '../models/config-model';
import { MutationTree } from 'vuex';
import { State } from './state';
import Vue from 'vue';
import { PanelFilterWidgetService } from '../services/panel-filter-widget-services'

export default <MutationTree<State>>{
  setFilters(state: State, filters: IFilter[]) {
    Vue.set(state, "filters", filters);
  },

  setPanels(state: State, panels: []) {
    Vue.set(state, "panels", panels);
  },

  setLabels(state: State, labels: []) {
    Vue.set(state, "labels", labels);
  },

  clearSelectedFilterOptions(state:State){
    state.filters.forEach(filter => {
      filter.options.forEach(o=>o.checked=false);
    });
  }, 

  setPanelActiveState(state: State, payload: { panel: IPanel, isActive: boolean }) {
    let index = state.panels.findIndex(panel=>panel.title==payload.panel.title);
    payload.panel.isActive=payload.isActive;
    Vue.set(state.panels, index, payload.panel);
  },

  resetFilterOptions(state: State, payload: { filterCode: string}){
    let stateFilter = state.filters.find(f=>f.code==payload.filterCode);
    if (!stateFilter) 
      return;

    stateFilter.options.forEach((option, index)=>{
      Vue.set(option, 'checked', false);
    });
  },

  toggleFilterOptionChecked(state: State, payload: { filterCode: string, filterOptionCode: string }){
    let stateFilter = state.filters.find(f=>f.code==payload.filterCode);
    if (!stateFilter) 
      return;

    let stateFilterOptionIndex = stateFilter.options.findIndex(o=>o.code==payload.filterOptionCode);
    let stateFilterOption  = stateFilter.options[stateFilterOptionIndex];
    
    stateFilterOption.checked = !stateFilterOption.checked;
    Vue.set(stateFilter.options, stateFilterOptionIndex, stateFilterOption);
  },

  setLoading(state: State, loading: boolean) {
    state.loading = loading
  },

  setTotalResults(state: State, count: number) {
    state.totalResults = count;
  },

  setInitialLoad(state: State, status: boolean) {
    state.initialLoad = status;
  },

  closeDetailPanel(state) {
    state.showDetailPanel = false;
  },

  openDetailPanel(state, panel: IPanel) {
    if (state.detailPanel?.title !== panel.title)
      state.detailPanel = panel;
    state.showDetailPanel = true;
  },

  closeDetailFilter(state) {
    state.showDetailFilter = false;
  },

  openDetailFilter(state, filter: IFilter) {
    if (state.detailFilter?.title !== filter.title)
      state.detailFilter = filter;
    state.showDetailFilter = true;
  },
  setConfig(state, config: IConfig) {
    state.config = config;
  },
  setPanelFilterWidgetService(state: State) {
    state.panelFilterWidgetService = new PanelFilterWidgetService(state.config.apibaseurl, state.config.language);
  },

  setError(state, error: string) {
    state.error = error;
  },
}
